const ParagraphIcon = () => (
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5 16.1667V2.89146C5 2.67526 5.17526 2.5 5.39146 2.5H11.0417C13.2278 2.5 15 4.27221 15 6.45833C15 8.64446 13.2278 10.4167 11.0417 10.4167H7.08333V16.1667C7.08333 16.4428 6.85948 16.6667 6.58333 16.6667H5.5C5.22386 16.6667 5 16.4428 5 16.1667ZM7.08333 4.16667V8.75H10.625C11.8907 8.75 12.9167 7.72399 12.9167 6.45833C12.9167 5.19268 11.8907 4.16667 10.625 4.16667H7.08333Z'
      fill='#818181'
    />
  </svg>
);

export default ParagraphIcon;
